import { ORDER_METHODS } from '../../../../services/exports/Constants';

export default {
  [ORDER_METHODS.delivery]: 'Kuljetus',
  [ORDER_METHODS.pickup]: 'Nouto',
  [ORDER_METHODS.room_service]: 'Huonepalvelu',
};
